import { useState, MouseEvent, FormEvent } from "react";
import { postReq } from "../../utils/request";
import classes from "./login.module.scss";
import auth from "./auth.module.scss";
import { useNavigate } from "react-router-dom";
import { setJwtToken } from "../../utils/token";
import Button from "../../components/Button";
import Input from "../../components/Input";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const [failedLoginFlag, setFailedLoginFlag] = useState('');
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const onLoginFormSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setEmailError("");
    setPasswordError("");

    if (!emailIsValid(email)) {
      setEmailError("Invalid Email format");
    }

    if (!passwordIsValid(password)) {
      setPasswordError("Password is too short");
    }
    // setTimeout(() => {
    //     setPasswordError("");
    //     setEmailError("");
    //   }, 10000);
    if (!email || !password) {
      return;
    }
    const resp = await postReq("users/login", {
      email,
      password,
    });
    if (resp.status === 200) {
      // navigate(`/2fa/${userId}`);
      const verificationToken = resp.body.accessToken;
      setJwtToken(verificationToken);
      navigate("/2fa");
      // navigate("/2fa", {
      //   state: {
      //     verificationToken: verificationToken,
      //   },
      // });
      return;
    }else if (resp.status === 400) {
        setEmailError("Email required");
        setPasswordError("Password required");
    }
    else if (resp.status === 403) {
        // Locked / disabled account — only returned after the password verified.
        setEmailError(resp.body.message);
    }
    else if (resp.status === 401) {
        // Uniform message: the server no longer distinguishes unknown email
        // from wrong password (prevents account enumeration).
        setPasswordError(resp.body?.message || "Invalid email or password");
    }
    else if (resp.status === 500) {
        setFailedLoginFlag("Unexpected error, please contact admin");
    }

    setTimeout(() => {
        setFailedLoginFlag('');
      }, 10000);
  };

  const emailIsValid = (email: string): boolean => {
    const emailValid = email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    return !!emailValid;
  };
  const passwordIsValid = (password: string): boolean => {
    return password.length >= 6;
  };
  const handleForgotPassword = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    navigate("/forgot-password");
  };
  return (
    <>
      {failedLoginFlag ? (
        <span className="errorClass" id="mainError">{failedLoginFlag}</span>
      ) : null}
      <div className={`container`}>
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="d-flex justify-content-between align-items-center">
              <span className="componentTitle">Sign in</span>
            </div>
            <form className={auth.authForm} onSubmit={onLoginFormSubmit}>
              <div className={auth.authField}>
                <Input
                  type="email"
                  id="email"
                  label="Email address"
                  value={email}
                  onChange={(_, value) => setEmail(String(value))}
                  nativeProps={{
                    name: "email",
                    autoFocus: true,
                    autoComplete: "username",
                    inputMode: "email",
                    autoCapitalize: "none",
                    spellCheck: false,
                    enterKeyHint: "next",
                  }}
                />
                {emailError ? (
                  <span className="errorClass">{emailError}</span>
                ) : null}
              </div>

              <div className="mb-3 position-relative">
                <div className={auth.authField}>
                  <Input
                    type="password"
                    id="password"
                    label="Password"
                    value={password}
                    onChange={(_, value) => setPassword(String(value))}
                    trimOnBlur={false}
                    nativeProps={{ name: "password", autoComplete: "current-password", enterKeyHint: "go" }}
                  />
                  {passwordError ? (
                    <span className="errorClass">{passwordError}</span>
                  ) : null}
                </div>
                <div
                  className={`d-flex justify-content-between ${classes.forgotPasswordContainer}`}
                >
                  <a href="/forgot-password" className={auth.authLink} onClick={handleForgotPassword}>Forgot password?</a>
                </div>
              </div>
              <div className={auth.authActions}>
                <Button type="submit" id="login" variant="primary" size="lg" className={classes.loginButton} title="Sign in with your email and password">
                  Sign in
                  <i
                    className={`bi bi-caret-right-fill`}
                  ></i>
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
